import React from "react";
import "./Csoon.scss";
import Comingsoon from "../../media/Chelia_Desktop.webp";
import Soon from "../../media/Chelia_Mobile.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6287713153298&text=Halo%20Billy,%20Saya%C2%A0bisa%20minta%20detail%20Promo%20terbaru%20rumah%20Summarecon%20Crown%20Gading%20(Chelia)+https://marketing-crowngading.com/&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="Chelia" className="container-bellefont">
      <div className="bellefont">
        <h1>New Launching Summarecon Crown Gading</h1>
        <h2>Cluster Chelia</h2>
      </div>
      <div className="maps-lokasi">
        <img className="img-Desktop" src={Comingsoon} alt="maps" />
        <img className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
